import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { ButtonWrapper, Column, ButtonIcon, Text, TextRegular, TextBold } from "./styles";

import StateService from "../../../services/State";
import handleURLParams from "../../../utils/handleURLParams";

function ButtonSelectState({ theme, link = "#!undefined" }) {
    const history = useHistory();
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const userUf = search.get('uf');

    const [userState, setUserState] = useState({});

    const handleUserState = useCallback(() => {
        const stateService = new StateService();

        if(userUf) {
            stateService.list({ filter: userUf }).then((response) => {
                if(response.data.payload.length === 1 ) {
                    setUserState(response.data.payload[0]);
                } 
            });
        } else {
            handleURLParams({ 
                listOfKeyValues: [{key: 'uf', value: 'TD'}],
                location: location,
                history: history
            });
        }
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userUf]);

    useEffect(() => {
        handleUserState()
    }, [handleUserState]);

    return (
        <ButtonWrapper className="SelectStateButton" theming={theme}>
            <Link to={{ pathname: link, search: history.location.search, state: { prevPath: location.pathname } }}>
            <Column className="Column" >
                <ButtonIcon className="AwesomeIcon">
                    <Icon icon={["fal", "map-marker-alt"]} />
                </ButtonIcon>
                <Text>
                    {userUf ? <TextRegular>Estado Selecionado: <TextBold>{userState.nome}</TextBold></TextRegular> : "Informe seu estado"}
                    {/* // {userUf ? `Estado Selecionado: ${userState.nome}` : "Informe seu estado"} */}
                </Text>
            </Column>

            <Column className="Column">
                <ButtonIcon className="AwesomeIcon">
                    <Icon icon={["far", "chevron-right"]} />
                </ButtonIcon>
            </Column>
            </Link>
        </ButtonWrapper>
    )
}

export default ButtonSelectState;